import { ActionIcon, Button, Flex, Text } from "@mantine/core";
import {
  BaseNodeAdditionalDataType,
  BaseNodeComponentType,
  BaseNodeDataType,
  BaseNodePropsType,
  getNodeLabel,
  SpecializedNodeProps,
} from "../WorkflowUtils";
import BaseNode from "./BaseNode";
import { IconPlus, IconX } from "@tabler/icons-react";

type GroupNodeAdditionalDataType = BaseNodeAdditionalDataType & {};

type GroupNodeDataType = BaseNodeDataType<GroupNodeAdditionalDataType>;

type Props = {} & BaseNodePropsType<GroupNodeDataType>;

/**
 * Group node.
 *
 * Used to define the workflow's entry point.
 * Is unique, there can be only one GroupNode, and it's required and must always be present.
 *
 * Displays a start icon.
 * Has only one east port.
 */
const GroupNode: BaseNodeComponentType<Props> = (props) => {
  return (
    <BaseNode {...props}>
      {(nodeProps: SpecializedNodeProps<GroupNodeDataType>) => {
        return (
          <div className={`node-content group-content`}>
            <Flex
              justify={"center"}
              align={"center"}
              style={{ position: "absolute", top: 10, left: 10 }}
            >
              {/*               <Text fw={500} mr="xs">
                {props.node?.data?.type
                  ? getNodeLabel(props.node?.data?.type)
                  : "N/A"}
              </Text> */}
              <Text fw={500} mr="xs">
                {props.node?.data?.type.toUpperCase() === "SERIAL_GROUP"
                  ? "Serial"
                  : props.node?.data?.type.toUpperCase() === "PARALLEL_GROUP"
                    ? "Parallel"
                    : ""}{" "}
                [ {props.node.id} ]
              </Text>
              {!props.isDisabled && (
                <>
                  <Button
                    size="sm"
                    variant="outline"
                    color="gray"
                    mr="xs"
                    onClick={() => {
                      props.onGroupAdd(props.node);
                    }}
                  >
                    Add
                  </Button>
                  <Button
                    size="sm"
                    variant="outline"
                    color="gray"
                    onClick={() => {
                      props.onDeleteNode(props.node);
                    }}
                  >
                    Delete
                  </Button>
                </>
              )}
            </Flex>
          </div>
        );
      }}
    </BaseNode>
  );
};

export default GroupNode;
